import { Box } from "@mui/material";
import type { TabPanelProps } from "./DealCompSectionTypes";

export function DealCompSectionTabPanel({
  children,
  value,
  index,
  variant = "default",
}: TabPanelProps) {
  if (value !== index) return null;

  const fill = variant === "fill";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: fill ? 0 : 2,
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        ...(fill ? { overflow: "hidden", height: "100%" } : {}),
      }}
    >
      {children}
    </Box>
  );
}
